export interface JournalCategoryModel {
  id: number;
  name: string;
  quadrantId: number;
}
